<template>
  <section id="table-section">
    <div id="tab-background"></div>
    <div id="table">
      <table-head
        @category-change="filterCategory"
        @sort-change="sortCategory"
      ></table-head>
      <table-data
        :chosenCategory="getChosenCategory"
        :orderCategory="getChosenSort"
      ></table-data>
    </div>
  </section>
</template>

<script>
import TableHead from "@/components/TableHead";
import TableData from "@/components/TableData";
export default {
  components: {
    TableHead,
    TableData,
  },
  data() {
    return {
      chosenCategory: "all",
      chosenSort: 1,
    };
  },
  methods: {
    filterCategory(category) {
      this.chosenCategory = category;
    },
    sortCategory(column) {
      this.chosenSort = column;
    },
  },
  computed: {
    getChosenCategory() {
      return this.chosenCategory;
    },
    getChosenSort() {
      return this.chosenSort;
    },
  },
};
</script>

<style lang="scss" scoped>
#table-section {
  height: 100%;
  min-height: 800px;
  background-color: $background-grey;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 30px;
}

#tab-background {
  height: 125px;
  background-color: $white;
  width: 100%;
}

div #table {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: -68px 10px 0px 10px;
  background-color: $white;

}
</style>